export default __webpack_public_path__ + "../img/dec6837c4cf66df6fcbc2fdf86a24915.png";